import loadable from '@loadable/component';

export default loadable(() => import('@ha/dsl'), {
  resolveComponent: components => components.Slider,
});

export type SliderProps = import('@ha/dsl').SliderProps;
